import { Controller } from "@hotwired/stimulus";

export class DismissibleAlertController extends Controller {
  static values = { key: String };

  connect() {
    if (this.#dismissed()) {
      this.element.hidden = true;
    }
  }

  dismiss() {
    try {
      sessionStorage.setItem(this.keyValue, "1");
    } catch (_) {
      // sessionStorage 利用不可（プライベートブラウズ等）でも UI は閉じる
    }
    this.element.hidden = true;
  }

  #dismissed() {
    try {
      return sessionStorage.getItem(this.keyValue) === "1";
    } catch (_) {
      return false;
    }
  }
}
